import { useEffect } from "react";
import { gardenModalTitle } from "../lib/results-garden";
import { themeScoreLabel } from "../lib/scoring";
import type { BloomThemeScore } from "../types/bloom-content";

interface ThemeDetailModalProps {
  theme: BloomThemeScore | null;
  onClose: () => void;
}

export function ThemeDetailModal({ theme, onClose }: ThemeDetailModalProps) {
  useEffect(() => {
    if (!theme) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [theme, onClose]);

  if (!theme) return null;

  return (
    <div
      className="bloom-theme-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bloom-theme-modal-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bloom-theme-modal">
        <h2 id="bloom-theme-modal-title" className="bloom-theme-modal__title">
          {gardenModalTitle(theme.themeId, theme.label)}
        </h2>
        <p className="bloom-theme-modal__score" aria-label={`Score ${theme.score} van ${theme.maxScore}`}>
          <span className="bloom-theme-modal__score-value">{theme.score}</span>
          <span className="bloom-theme-modal__score-max">/ {theme.maxScore}</span>
        </p>
        <p className="bloom-theme-modal__label">{themeScoreLabel(theme.score, theme.maxScore)}</p>
        <p className="bloom-theme-modal__summary">{theme.summary}</p>
        <div className="bloom-theme-modal__actions">
          <button type="button" className="bloom-btn bloom-btn--primary" onClick={onClose}>
            Sluiten
          </button>
        </div>
      </div>
    </div>
  );
}
